import {
  AfterContentInit,
  Component,
  HostListener,
  NgZone,
  OnChanges,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { Router } from "@angular/router";
import Clarity from "@microsoft/clarity";
import { PrimeNGConfig } from "primeng/api";
import { environment } from "src/environments/environment";
import { CLARITY_MAP } from "./_helper/clarity.config";
import { RouterExtService } from "./_services/common/router-ext.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
})
export class AppComponent implements OnInit, OnChanges, AfterContentInit {
  currentWidth: number;
  currentHeight: number;
  horizontalMenu: boolean;

  darkMode = false;

  menuColorMode = "light";

  menuColor = "layout-menu-light";

  themeColor = "blue";

  layoutColor = "blue";

  ripple = true;

  inputStyle = "outlined";

  constructor(
    private primengConfig: PrimeNGConfig,
    private router: Router,
    private zone: NgZone,
    private routerExtService: RouterExtService,
  ) {}

  ngOnInit() {
    //Clarity Integration Start
    if (environment.production) {
      const hostname = window.location.hostname;
      const clarityId = CLARITY_MAP[hostname];

      if (clarityId) {
        this.zone.runOutsideAngular(() => {
          Clarity.init(clarityId);
          // console.log(`Clarity initialized for: ${hostname} and ClarityId ${clarityId}`);
        });
      } else {
        console.warn(`Clarity ID not found for domain: ${hostname}`);
      }
    }
    //Clarity Integration End

    //const token = this.getToken();
    const token = sessionStorage.getItem("token");
    if (!token) {
      localStorage.clear();
      this.router.createUrlTree(["/login"]);
    }
    this.primengConfig.ripple = true;
    this.onResize();
    const savedUrl = localStorage.getItem("currentUrl");
    if (savedUrl && savedUrl !== "/login") {
      // Navigate to the saved URL after the page reload
      this.router.navigateByUrl(savedUrl, { skipLocationChange: true });
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.onResize();
  }

  ngAfterContentInit(): void {
    // If the current URL is still /auth/login, redirect to root with skipLocationChange
    if (this.routerExtService.getCurrentUrl().includes("/login")) {
      this.routerExtService.router.navigateByUrl("/", {
        skipLocationChange: true,
      });
    }
  }

  @HostListener("window:beforeunload", ["$event"])
  unloadHandler(event: Event): void {
    console.log("Beforeunload event triggered");
    const current = this.routerExtService.getCurrentUrl();
    console.log("Saving URL:", current);
    localStorage.setItem("currentUrl", current);
  }
  onResize() {
    this.currentWidth = window.innerWidth;
    this.currentHeight = window.innerHeight;
    let compressWSize =
      this.currentWidth - Math.round(this.currentWidth * 0.02);
    let compressHSize =
      this.currentHeight - Math.round(this.currentHeight * 0.1);
    // You can add conditions or actions based on new sizes
    // console.log(`Width: ${this.currentWidth}, Height: ${this.currentHeight}`);

    // console.log(`compress Width: ${compressWSize}, compress Height: ${compressHSize}`);

    // Example: Different actions based on screen width
    if (this.currentWidth < 768) {
      // console.log('Screen size is small (mobile view).');
      window.resizeTo(compressWSize, this.currentHeight);
      // Perform actions for small screens
    } else if (this.currentWidth >= 768 && this.currentWidth < 1024) {
      // console.log('Screen size is medium (tablet view).');
      window.resizeTo(compressWSize, this.currentHeight);
      // Perform actions for medium screens
    } else {
      // console.log('Screen size is large (desktop view).');
      window.resizeTo(compressWSize, this.currentHeight);
      // Perform actions for large screens
    }
  }
}
